import React from 'react';
import dynamic from 'next/dynamic';
import { getCategoriesTree } from '@fh-components/fh-js-api-core/store/slices/categoriesSlice';
import { Loader } from '@/components';
import { MetaData } from '@/containers';

const CatalogSeoPage = dynamic(() => import('../../layouts/CatalogSeoPage'), {
	loading: () => <Loader />,
});

const CatalogPage = ({ tree }) => {
	return (
		<>
			<MetaData title='Каталог' description='Карта сайта со ссылками на все категории' />
			<CatalogSeoPage tree={tree} />
		</>
	);
};

CatalogPage.getInitialProps = async ({ reduxStore }) => {
	let tree;
	await reduxStore.dispatch(
		getCategoriesTree({
			onSuccess: result => {
				tree = result.data;
			},
		}),
	);

	return { tree };
};

export default CatalogPage;
